module.exports = __webpack_public_path__ + "Qqx6JfPDtXSiUWszk/illo-couple-phone.svg";